module.exports = "/assets/a2b241f02331a66fcd185a5148df8d6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/SQ.png
// module id = 1830
// module chunks = 0